import React from 'react';
import PropTypes from 'prop-types';

function AboutUs() {
  return (
    <main className="site--width">
      <div className='plain_content'>
        <h2 className="main_title">ABOUT US</h2>
        <div>
          <p>
            MedCafe.ie is a one stop shop for Doctors and other healthcare professionals to:
          </p>
          <p>
            <ol>
              <li>access and participate in Online Webinars on a range of different topics all in one place.</li>
              <li>access a meeting with a physical audience by way of our Live Streaming Service (i.e. A GP Study Day or an educational evening at a hotel/conference centre).</li>
            </ol>
          </p>
 
          <p>
            MedCafe was launched in May 2018 by Bill Coghlan and GPBuddy.ie and to date over 1,500 Doctors in Ireland have registered with MedCafe.ie. This number continues to grow daily as we continue to add more high quality educational modules to the platform.
          </p>
          <div className="founders_container">
            <div className="founder_logo founder_logo_resize">
              <img src="/assets/img/bill_coghlan.jpg" />
              <p className="founder_label">
                Bill Coghlan
              </p>
            </div>
            <div className="founder_logo">
              <img src="/assets/img/darach.png" />
              <p className="founder_label">
                Dr. Darach O’Ciardha
              </p>
            </div>
            <div className="founder_logo">
              <img src="/assets/img/shane.png" />
              <p className="founder_label">
                Dr. Shane McKeogh
              </p>
            </div>
            <div className="founder_logo">
              <img src="/assets/img/eoin_newell.jpg" />
              <p className="founder_label">
                Eoin Newell
              </p>
            </div>
          </div>
          <p>
            If you need to contact us for any reason, please email us at <span>support@medcafe.ie.</span> We would love to hear from you.
          </p>
        </div>
      </div>
    </main>
  );
}

AboutUs.defaultProps = {};

AboutUs.propTypes = {};

export default AboutUs;



/** WEBPACK FOOTER **
 ** ./src/components/Plain/AboutUs.jsx
 **/